import { MapContainer, Marker, TileLayer, useMapEvents, useMap } from "react-leaflet";
import 'leaflet/dist/leaflet.css';
import { useEffect, useState } from "react";


const Mapa = ({ latitud, longitud, zoom = 13 }, ) => {

    // const [position, setPosition] = useState(null);
    const [center, setCenter] = useState([latitud || -38.95161 , longitud || -68.0591])

    useEffect(() => {
        if (latitud && longitud) {
            setCenter([Number(latitud), Number(longitud)])
        }
    }, [latitud, longitud])

    const GetPosicion = ({ position }) => {
        const map = useMap()
        useEffect(() => {
            if (position) {
                map.flyTo(position, map.getZoom(), 5)
            }

        }, [position, map])
    }

    return (
        <>
            <MapContainer className="w-100 h-100" center={center} zoom={zoom} attributionControl={false}>
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {
                    (latitud && longitud) && <Marker position={[latitud, longitud]} />
                }
                <GetPosicion position={center} />
            </MapContainer>
        </>

    );
}

export default Mapa;